import type { PartialDeep } from 'type-fest';
import { Configuration } from '../defaultConfig';
import updatedDefaultNetworkConfigsWithProdIssuer from '../configUtils';
import { IdentityStoreEndpoints } from '../identityStore';

const stageConfig: PartialDeep<Configuration> = {
  services: {
    walletBalanceService: { endpoint: 'https://api.civic.com/balance-lookup' },
    identityStore: { endpoint: IdentityStoreEndpoints.prod },
    civicAnalytics: {
      endpoint: 'https://api.civic.com/analytics/events',
      // 'source' is how the analytics-proxy knows where to route our events.
      // Same as the componentTag but renamed now that we're no longer tied to CML / Segment for generic event streams.
      // Since the analytics endpoint can now ingest events from multiple sources (it lives with analytics-proxy), the source name has to be sent through by each client.
      // We still use 'passApi' instead of 'passIframe' until we can migrate the legacy Redshift data.
      // The source currently maps to a Segment source, which is used as the Redshift schema which we are not renaming right now.
      source: 'passApi_prod',
    },
    configEndpoint: 'https://api.civic.com/cw-services-prod/browser-configs',
    conversionService: {
      endpoint: 'https://api.civic.com/tx-cost-service/conversion',
    },
    sip: {
      sipEndpoint: 'https://api.civic.com/sip/prod/v3/scopeRequest',
      defaultSipAppId: '6t8V0gDh1',
    },
    gatekeeperNetworkService: {
      endpoint: 'https://api.civic.com/gkn',
    },
    gatekeeperFaceIdSearch: {
      endpoint: 'https://gatekeeper-api.civic.com/v1/record/search',
    },
    validation: {
      // authEndpoint: 'https://d3bdeymts6zt5a.cloudfront.net', // lambda@edge
      authEndpoint: 'https://api.civic.com/sign', // lambda
      validationEndpoint: 'https://api.civic.com/pass',
    },
    retention: {
      retentionEndpoint: 'https://api.civic.com/pass-retention-service/v0',
    },
    uniqueness: {
      revocationPortalUrl: 'https://revoke.civic.com/uniqueness',
    },
    facetecProductionMode: true,
    captchaKeys: {
      reCaptchaKey: '6LdInXEdAAAAAOm4CWhA03MYkPsIQRKt_mtJjjUl',
      hCaptchaKey: '3fe6bf88-7035-45b7-8f56-c9de61a1ca48',
    },
    zendeskWidget: {
      key: '14f0c6cc-519e-4208-8873-89bfbe0abc6f',
      fieldsId: {
        did: '4771628616855',
        flowId: '360035572454',
        validationId: '1900007355045',
        screenId: '1500015760402',
      },
    },
  },
  flowConfigs: updatedDefaultNetworkConfigsWithProdIssuer(),
};

export default stageConfig;
